import { getBaseURL } from "lib/helpers";

export const DEFAULT_ERROR_MESSAGE =
  "An unexpected error happened. Please contact us.";

export const BASE_SERVER_URL = getBaseURL();
export const ORDERBOOK_URL = `${BASE_SERVER_URL}/orderbook/api`;
export const ATLAS_URL = `${BASE_SERVER_URL}/api`;
export const DIRECTORY_URL = `${BASE_SERVER_URL}/accounts`;
export const INVENTORY_URL = `${BASE_SERVER_URL}/inventory`;

// times in milliseconds
export const longDebounceTime = 500;
